/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum AreaOfStudyCategory {
  AppliedScience = "AppliedScience",
  BusinessGovernmentEducationAndMedia = "BusinessGovernmentEducationAndMedia",
  FormalScience = "FormalScience",
  Humanities = "Humanities",
  Languages = "Languages",
  Law = "Law",
  NaturalScience = "NaturalScience",
  SocialScience = "SocialScience",
}

export const AreaOfStudyCategoryDisplay: Record<AreaOfStudyCategory, string> = {
  [AreaOfStudyCategory.AppliedScience]: "Applied Science",
  [AreaOfStudyCategory.BusinessGovernmentEducationAndMedia]: "Business, Government, Education & Media",
  [AreaOfStudyCategory.FormalScience]: "Formal Science",
  [AreaOfStudyCategory.Humanities]: "Humanities",
  [AreaOfStudyCategory.Languages]: "Languages",
  [AreaOfStudyCategory.Law]: "Law",
  [AreaOfStudyCategory.NaturalScience]: "Natural Science",
  [AreaOfStudyCategory.SocialScience]: "Social Science",
};
